import EventEmitter from 'eventemitter3';

export class NotificationDispatcher extends EventEmitter {}

export const notificationDispatcher = new NotificationDispatcher();
